import React, { FunctionComponent } from 'react';
import { Checkbox, CheckboxProps } from 'reakit/Checkbox';

export interface CKSwitchProps extends CheckboxProps {
  id: string;
}

export const CKSwitch: FunctionComponent<CKSwitchProps> = ({
  id,
  children,
  ...rest
}) => {
  return (
    <div className="ck-switch">
      <Checkbox id={id} className="ck-switch-input" {...rest} />
      <label htmlFor={id} className="ck-switch-label">
        <div className="ck-switch-track">
          <div className="ck-switch-knob">
            <div className="ck-switch-knob-inner"></div>
          </div>
        </div>
        {children && <span className="ck-switch-text">{children}</span>}
      </label>
    </div>
  );
};
